import { Grid, useEventCallback } from '@mui/material';
import { ForeignForm } from 'shell/view-models/foreign-form';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityList, {
  MunicipalityAnprVM,
} from 'shell/components/shared/foreign-municipality-list';

interface ForeignComponentProps {
  disabled?: boolean;
  isEditMode?: boolean;
  values?: ForeignForm;
  errors?: FormikErrors<ForeignForm>;
  touched?: FormikTouched<ForeignForm>;
  onChange: (key: keyof ForeignForm, value: ForeignForm[keyof ForeignForm]) => void;
}

const ForeignComponent = ({
  disabled,
  isEditMode,
  values,
  errors,
  onChange,
}: ForeignComponentProps): React.ReactElement => {
  const handleForeignStateListChange = useEventCallback(
    (state: ForeignStateVM | null | undefined) => {
      onChange('state', state);
    }
  );

  const onChangeForeignMunicipality = useEventCallback(
    (municipality: MunicipalityAnprVM | null | undefined) => {
      onChange('municipality', municipality);
    }
  );

  return (
    <Grid
      item
      xs={12}
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={{ xs: 1, md: 0 }}
    >
      <Grid item xs={12} md={6}>
        <ForeignStateList
          required
          value={values?.state || null}
          onChange={handleForeignStateListChange}
          disabled={isEditMode ? false : disabled}
          label="Stato estero di nascita"
          id="foreignStateBirth"
          error={Boolean(errors?.state)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MunicipalityList
          value={values?.municipality}
          disabled={!values?.state?.istatCode || disabled}
          istatCodeState={values?.state?.istatCode}
          onChange={onChangeForeignMunicipality}
          label="Comune estero di nascita"
          id="foreignMunicipality"
          error={!!errors?.municipality}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="county"
          name="county"
          fullWidth
          disabled
          type="text"
          variant="outlined"
          value={values?.province || values?.municipality?.province || ''}
          onChange={(event) => {
            onChange('province', event.target.value);
          }}
          inputProps={{
            maxLength: '30',
          }}
        />
      </Grid>
    </Grid>
  );
};

ForeignComponent.displayName = 'Foreign generality component';

const Foreign = memo(ForeignComponent);

export default Foreign;
